'use strict'

var normalize = require('mdurl/encode')

module.exports = image

/* Transform an image. */
function image(h, node) {
  var props = {src: normalize(node.url), alt: node.alt}

  if (node.title !== null && node.title !== undefined) {
    props.title = node.title
  }

  return h(node, 'img', props)
}



//////////////////
// WEBPACK FOOTER
// ./~/remark-react/~/mdast-util-to-hast/lib/handlers/image.js
// module id = 895
// module chunks = 95715928098905 168707334958949